<template>
  <div
    v-if="state"
    class="san-infinite-hits"
  >
    <slot
      v-if="showPrevious"
      name="loadPrevious"
      :refine-previous="refinePrevious"
      :page="state.results.page"
      :is-first-page="state.isFirstPage"
    >
      <button
        class="loadPrevious"
        :class="[
          state.isFirstPage && 'loadPrevious disabled',
        ]"
        :disabled="state.isFirstPage"
        @click="refinePrevious()"
      >
        Show previous results
      </button>
    </slot>

    <slot
      :items="state.items"
      :results="state.results"
      :banner="state.banner"
      :is-last-page="state.isLastPage"
      :refine-previous="refinePrevious"
      :refine-next="refineNext"
      :refine="refineNext"
      :insights="state.insights"
      :send-event="state.sendEvent"
    >
      <template v-if="showBanner && state.banner && state.banner.image.urls[0].url">
        <slot
          name="banner"
          :banner="state.banner"
        >
          <aside class="banner">
            <a
              v-if="state.banner.link"
              :href="state.banner.link.url"
              :target="state.banner.link.target"
              class="banner-link"
            >
              <img
                :src="state.banner.image.urls[0].url"
                :alt="state.banner.image.title"
                class="banner-image"
              >
            </a>
            <img
              v-else
              :src="state.banner.image.urls[0].url"
              :alt="state.banner.image.title"
              class="banner-image"
            >
          </aside>
        </slot>
      </template>
      <ol class="list">
        <li
          v-for="(item, index) in state.items"
          :key="item.objectID"
          class="item"
          @click="state.sendEvent('click:internal', item, 'Hit Clicked')"
          @auxclick="state.sendEvent('click:internal', item, 'Hit Clicked')"
        >
          <slot
            name="item"
            :item="item"
            :index="index"
            :insights="state.insights"
            :send-event="state.sendEvent"
          >
            objectID: {{ item.objectID }}, index: {{ index }}
          </slot>
        </li>
      </ol>

      <slot
        name="loadMore"
        :refine-next="refineNext"
        :refine="refineNext"
        :page="state.results.page"
        :is-last-page="state.isLastPage"
      >
        <button
          class="loadMore"
          :class="[
            state.isLastPage && 'loadMore disabled',
          ]"
          :disabled="state.isLastPage"
          @click="refineNext()"
        >
          Show more results
        </button>
      </slot>
    </slot>
  </div>
</template>

<script setup>
import { watch } from 'vue'
import { connectInfiniteHitsWithInsights } from 'instantsearch.js/es/connectors'
import { useConnector } from '@/composables'

defineOptions({ name: 'SanInfiniteHits' })
const emit = defineEmits(['totalHitsUpdated'])
const props = defineProps({
  showBanner: { type: Boolean, default: true },
  showPrevious: { type: Boolean, default: false },
  escapeHTML: { type: Boolean, default: true },
  transformItems: { type: Function, default: undefined },
  cache: { type: Object, default: undefined }
})

const { state } = useConnector({ connector: connectInfiniteHitsWithInsights, props })

const refinePrevious = () => state.value.showPrevious()
const refineNext = () => state.value.showMore()

watch(() => state.value?.results.nbHits, val => emit('totalHitsUpdated', val))
</script>
